import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import 'react-perfect-scrollbar/dist/css/styles.css';
import '../styles.scss';
import { Link } from 'react-router-dom';
import { CitiesList } from './CitiesList';
import { CountriesList } from './CountriesList';

const CountryStatistics = ({
    data,
    countries,
    isMobile,
    selectedCountry,
    onCountrySelect,
    onClose,
}) => {
    const { cities, cityData, auditScore } = useMemo(() => {
        return data[selectedCountry] || {};
    }, [data, selectedCountry]);

    const [selectedCity, selectCity] = useState('');

    const cityIsInSelectedCountry = cities && cities.includes(selectedCity);

    useEffect(() => {
        if (!cityIsInSelectedCountry) {
            selectCity('');
        }
    }, [cityIsInSelectedCountry, selectedCity]);

    return (
        <div className="geo-data">
            {selectedCountry && (
                <div className="geo-data--title" onClick={() => onCountrySelect('')}>
                    <div>
                        <p>
                            {selectedCountry} - 3rd Party Audited: {auditScore}%
                        </p>
                        <p style={{ fontSize: 16 }}>*Audits are Semi Announced.</p>
                    </div>
                    <span className={'menu-icon arrow-close'} />
                </div>
            )}
            {selectedCountry ? (
                <>
                    <CitiesList
                        onSelect={city => {
                            selectCity(city !== selectedCity ? city : '');
                        }}
                        cities={cities}
                        cityData={cityData}
                        citySelected={selectedCity}
                    />
                    <div className="map-menu-last">
                        <Link
                            to="/modern-slavery"
                            title="Modern Slavery"
                            className="fg-yellow invert modern-slavery-cities"
                        >
                            <i />
                            <span>Modern Slavery</span>
                        </Link>
                    </div>
                </>
            ) : (
                <CountriesList countries={countries} onSelect={onCountrySelect} />
            )}
        </div>
    );
};

CountryStatistics.props = {
    selectedCountry: PropTypes.string,
    isMobile: PropTypes.bool,
    onCountrySelect: PropTypes.func,
    onClose: PropTypes.func,
};

const mapSizesToProps = ({ width }) => ({
    isMobile: width <= 1024,
});

export default withSizes(mapSizesToProps)(CountryStatistics);
